<ng-container *ngIf="isListType; else modifyMessage">
    <div style="width: fit-content">
        <sh-form-select
            [id]="id"
            [control]="mergeStrategyControl"
            [style]="formSelectStyle.Ghost"
            [options]="mergeStrategyOptions"
            [showEmptyOption]="false"
        ></sh-form-select>
    </div>
</ng-container>

<ng-template #modifyMessage>
    <p class="sh-merge-strategy-label">{{ "records.batch-edit.modify-to" | translate }}</p>
</ng-template>
